import { useEffect } from 'react';
import { foldBundlesIntoServices } from './draftsBundleFold';
import { useDraftsAiSearchStore } from './useDraftsAiSearchStore';
export const useBundlesFoldedIntoServices = ()=>{
    const filter = useDraftsAiSearchStore((s)=>s.filter);
    const lastQuery = useDraftsAiSearchStore((s)=>s.lastQuery);
    const setFilter = useDraftsAiSearchStore((s)=>s.setFilter);
    useEffect(()=>{
        if (filter == null) return;
        const folded = foldBundlesIntoServices(filter);
        if (folded !== filter) setFilter(folded, lastQuery);
    }, [
        filter,
        lastQuery,
        setFilter
    ]);
};
